import { apiRequest } from "./client";
import { activeExam } from "../lib/activeExam";

/** Public calls carry no header: the exam goes in the query instead. */
function examQuery(exam: string | null = activeExam()): string {
  return exam ? `?exam=${exam}` : "";
}

export interface AvailableYear {
  year: number;
  questionCount: number;
}

export interface TopicWithMastery {
  id: string;
  name: string;
  /** null when never attempted — "not started", never 0%. */
  mastery: number | null;
  weak: boolean;
  questionCount: number;
}

/** Years that actually hold questions for this subject. Public. */
export function fetchYears(subjectId: string): Promise<{ years: AvailableYear[] }> {
  return apiRequest<{ years: AvailableYear[] }>(`/api/subjects/${subjectId}/years${examQuery()}`);
}

/** The syllabus with this student's mastery, weakest first. */
export function fetchTopics(subjectId: string): Promise<{ topics: TopicWithMastery[] }> {
  return apiRequest<{ topics: TopicWithMastery[] }>(`/api/subjects/${subjectId}/topics`, {
    authenticated: true,
  });
}

export interface OfflinePackResponse {
  subjectId: string;
  count: number;
  questions: {
    id: string;
    stem: string;
    options: Record<string, string> | null;
    correctAnswer: string | null;
    explanation: string | null;
    topicId: string | null;
    topicName: string | null;
    examYear: number | null;
  }[];
}

/**
 * A subject's questions for offline practice.
 *
 * Public and cached hard by the service worker — the question bank is not
 * personal data and a 2019 past question is the same question tomorrow.
 */
export function fetchPack(
  subjectId: string,
  exam: string | null = activeExam(),
): Promise<OfflinePackResponse> {
  return apiRequest<OfflinePackResponse>(`/api/subjects/${subjectId}/pack${examQuery(exam)}`);
}
